/* eslint-disable @typescript-eslint/no-unused-expressions, @babel/no-unused-expressions */

/**
 * Forces reflow on the specified element.
 */
export default function forceReflow(element) {
  // @ts-ignore
  element.offsetHeight;
}
//# sourceMappingURL=forceReflow.js.map